import { QueryFactory } from "../../../../Common";
import { Player } from "../../../../Contracts";
export const QGetPlayer = QueryFactory(Player.QueryTypes.GetPlayer);
//# sourceMappingURL=QGetPlayer.js.map